module.exports = __webpack_public_path__ + "static/Edmondsans_Bold-4a3a6523c2e50bc2a8de4445564c1cc1.ttf";